// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Plus_Jakarta_Sans_646807', '__Plus_Jakarta_Sans_Fallback_646807'","fontStyle":"normal"},"className":"__className_646807"};